import { THttpService } from '@/services/HttpService';

import { TResponseVoucherData, TVoucherData } from './types';

const formatSuccess = async (
  data: TResponseVoucherData,
): Promise<TVoucherData> => {
  const formatedResponse: TVoucherData = {
    ...data,
  };
  return formatedResponse;
};

export const voucherList = async (api: THttpService): Promise<TVoucherData> => {
  const path = '/checkout/voucher/v1/search';
  try {
    const response = await api.post(path, {});
    const voucherResponse = await formatSuccess(response.data);
    return voucherResponse;
  } catch (error) {
    throw new Error((error as { message: string }).message);
  }
};
